// Liens saisis par des utilisateurs publics (réseaux sociaux des candidats
// ambassadeurs, résultats de course…) : seules les URL http(s) deviennent des
// liens. React n'empêche pas `javascript:` dans href ; un clic d'admin aurait
// exécuté du code sur l'origine de pikachu (jeton de session en localStorage).
export function safeHref(url) {
  const value = String(url || "").trim();
  return /^https?:\/\//i.test(value) ? value : undefined;
}
